import Select from "react-select";
import { Constants } from "../Constants";
import RequiredIcon from "./RequiredIcon";

const ReactSelect = ({
  options,
  value,
  touched,
  errors,
  onChange,
  label,
  required,
  isDisabled,
  placeholder,
  isClearable = false
}) => {
  return (
    <>
      {label && <label className="form-label">{label}</label>}
      {required && <RequiredIcon />}
      <Select
        isDisabled={isDisabled || false}
        value={value}
        onChange={(e) => onChange(e)}
        options={options}
        placeholder={placeholder || Constants.select}
        isClearable={isClearable}
      />
      {(touched ? errors : undefined || touched) && (
        <p className="error-msg">{touched ? errors : undefined}</p>
      )}
    </>
  );
};

export default ReactSelect;
